import Amount from "./amount";
import PaymentMethods from "./methods/methods";

const PaymentContent = ({
  data,
  handleBankInfo,
  onChangeMethods,
  paymentMethod,
}) => {
  return (
    <>
      <Amount data={data} />
      <PaymentMethods
        data={data}
        paymentMethod={paymentMethod}
        handleBankInfo={handleBankInfo}
        onChangeMethods={onChangeMethods}
      />
    </>
  );
};
export default PaymentContent;
